import { render, staticRenderFns } from "./palette.vue?vue&type=template&id=8187ec26&"
import script from "./palette.vue?vue&type=script&lang=js&"
export * from "./palette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports